// extracted by mini-css-extract-plugin
export default {"button":"WJfVz","wrapper":"eB1mv","label":"wpTyG"};